import gql from "graphql-tag";
import api from "../apiClient";

export default {
  list: () =>
    api
      .send({
        query: gql`
          query tarifa {
            TYPES {
              Tarifa {
                readAll {
                  id
                  value
                  annotation
                  tarifa
                }
              }
            }
          }
        `,
      })
      .then((result) => result.data.data.TYPES.Tarifa.readAll),
};
